module.exports = __webpack_public_path__ + "img/facilities_04.3d2be1b4.jpg";